import urlParser from 'js-video-url-parser/lib/base';
import {YouTubeVideoInfo} from 'js-video-url-parser';
import 'js-video-url-parser/lib/provider/youtube';
import spotifyUri, {Track, Playlist, Episode, Album, Artist} from 'spotify-uri';

import {LinkType} from '../types';

import {AMAZON_URL_REGEX} from './constants';

export const getMedia = (
  url?: string,
): {type: LinkType; mediaId?: string} | undefined => {
  if (!url) {
    return;
  }

  const parsedUrl = urlParser.parse(url);
  let spotifyInfos;
  try {
    // spotifyUri.parse will throw if the url is not valid
    spotifyInfos = spotifyUri.parse(url);
  } catch {
    spotifyInfos = undefined;
  }

  if (parsedUrl?.provider === 'youtube') {
    const youtubeVideoInfos = parsedUrl as YouTubeVideoInfo;
    if (parsedUrl?.mediaType === 'video') {
      return {
        type: LinkType.YouTubeVideoLink,
        mediaId: youtubeVideoInfos.id,
      };
    }

    if (parsedUrl?.mediaType === 'playlist') {
      return {
        type: LinkType.YouTubePlaylistLink,
        mediaId: youtubeVideoInfos.list,
      };
    }
  }

  if (spotifyInfos) {
    if (spotifyInfos instanceof Track) {
      return {
        type: LinkType.SpotifySongLink,
        mediaId: spotifyInfos.id,
      };
    }

    if (spotifyInfos instanceof Album) {
      return {
        type: LinkType.SpotifyAlbumLink,
        mediaId: spotifyInfos.id,
      };
    }

    if (spotifyInfos instanceof Playlist) {
      return {
        type: LinkType.SpotifyPlaylistLink,
        mediaId: spotifyInfos.id,
      };
    }

    if (spotifyInfos instanceof Artist) {
      return {
        type: LinkType.SpotifyArtistLink,
        mediaId: spotifyInfos.id,
      };
    }

    if (spotifyInfos instanceof Episode) {
      return {
        type: LinkType.SpotifyPodcastLink,
        mediaId: spotifyInfos.id,
      };
    }

    if (spotifyInfos.type === 'show') {
      return {
        type: LinkType.SpotifyShowLink,
        mediaId: (spotifyInfos as any).id,
      };
    }
  }

  if (AMAZON_URL_REGEX.test(url)) {
    return {
      type: LinkType.AmazonAffiliateLink,
    };
  }
};
